import { filter, ignoreElements, map, mergeMap, switchMap, tap } from 'rxjs/operators';
import { ofType } from 'redux-observable-es6-compat';
import { AGetAudioDevicesSuccess, ASetAudioDeviceSuccess, TAudioDevice } from '../actions/audio-device.actions';


export const SetAudioDeviceEpic = (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TAudioDevice.SET_AUDIO_DEVICE),
    switchMap(({ payload }) => restApi.get(`/setaudiodevice/${payload}?ngsw-bypass=true`)),
    map(ASetAudioDeviceSuccess),
  );

export const GetAudioDevicesEpic = (action$, _, { restApi }) =>
  action$.pipe(
    ofType(TAudioDevice.GET_AUDIO_DEVICES),
    switchMap(() => restApi.get(`/audioDevices?ngsw-bypass=true`)),
    map((payload) => AGetAudioDevicesSuccess(payload)),
  );

